// extracted by mini-css-extract-plugin
var _1 = "Notifications_answer__cUyLe";
var _2 = "Notifications_answers__rrwAI";
var _3 = "Notifications_author__VHRZB";
var _4 = "Notifications_board__BN-gr";
var _5 = "Notifications_date__Gj0K5";
var _6 = "Notifications_firstItemButton__u7H1l";
var _7 = "Notifications_item__lejGq";
var _8 = "Notifications_itemButton__Zc1FT";
var _9 = "Notifications_itemContent__glztO";
var _a = "Notifications_itemFullScreen__jQz0T";
var _b = "Notifications_itemHeader__TmgY-";
var _c = "Notifications_itemRead__RDKEA";
var _d = "Notifications_link__RiQXY";
var _e = "Notifications_project__Sf4NC";
var _f = "Notifications_systemContent__KOY7o";
var _10 = "Notifications_systemNotificationResponseWrapper__qJ1Dq";
var _11 = "Notifications_systemTag__RID7q";
var _12 = "Notifications_systemTitle__zub+0";
var _13 = "Notifications_systemUser__AXXrL";
var _14 = "Notifications_user__hj4uB";
var _15 = "Notifications_wrapper__EHJBh";
export { _1 as "answer", _2 as "answers", _3 as "author", _4 as "board", _5 as "date", _6 as "firstItemButton", _7 as "item", _8 as "itemButton", _9 as "itemContent", _a as "itemFullScreen", _b as "itemHeader", _c as "itemRead", _d as "link", _e as "project", _f as "systemContent", _10 as "systemNotificationResponseWrapper", _11 as "systemTag", _12 as "systemTitle", _13 as "systemUser", _14 as "user", _15 as "wrapper" }
